import React from 'react'
import { componentGetCompareProps } from 'common-tools/index'
import AceEditor from 'react-ace'
import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/theme-github'

export class JsonEditor extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      containerHeight: 0,
      containerWidth: 0,
      firstRenderDone: false
    }
  }

  wrapperDiv = null

  componentDidMount () {
    this.updateDimensions()

    // const { readOnly = false } = this.props
    // if (readOnly === true) {
    //   const editor = this.wrapperDiv?.editor
    //   if (editor) {
    //     editor.setReadOnly(true)
    //   }
    // }
  }

  componentDidUpdate (prevProps, prevState) {
    const splitSize = componentGetCompareProps('splitSize', this.props, prevProps, 0)

    if (!this.props.noResize && splitSize.HasChanged) {
      this.updateDimensions()
    }

    // const readOnly = componentGetCompareProps('readOnly', this.props, prevProps, false)
    // if (readOnly.HasChanged) {
    //   const editor = this.wrapperDiv?.current?.editor
    //   if (editor) {
    //     editor.setReadOnly(readOnly.Current)
    //   }
    // }
  }

  updateDimensions () {
    if (this.wrapperDiv) {
      const rect = this.wrapperDiv.getBoundingClientRect()
      this.setState({
        containerHeight: rect.height,
        containerWidth: rect.width
      })
    }
  }

  render () {
    const { containerHeight, containerWidth } = this.state
    const { className, style, noResize = false, ...rest } = this.props

    if (noResize) {
      return <AceEditor
        {...rest}
        height='100%'
        width='100%'
        theme='github'
        mode='json'
      />
    } else {
      return <div className={className} style={style} ref={(c) => { this.wrapperDiv = c }}>
        <AceEditor
          {...rest}
          height={`${containerHeight}px`}
          width={`${containerWidth}px`}
          theme='github'
          mode='json'
        />
      </div>
    }
  }
}
